export default function getListCountries(data) {
  let countries = [];
  for (let item of data) {
    if (!countries.includes(item.country)) {
      countries.push(item.country);
    }
  }
  return countries;
}
